export const secClassMap: { [key: number]: string } = {
  1: 'Treasuries',
  2: 'Agencies (Fixed)',
  3: 'Corporates (Fixed)',
  4: 'Municipals Taxable (Fixed)',
  5: 'Municipals (Fixed)',
  6: "CD's (Fixed)",
  7: 'MBS (Fixed)',
  8: 'CMO (Fixed)',
  9: 'Corporates (Float)',
  10: 'MBS (Float)',
  11: 'CMO (Float)',
  12: 'Agencies (Float)',
  13: 'SBA Pools (Fixed)',
  14: 'SBA Pools (Float)',
  15: 'Stock/Preferred (Fixed)',
  16: 'Stock/Preferred (Float)',
  17: 'CMBS Pools (Fixed)',
  18: 'CMBS Pools (Float)',
  19: 'ABS (Fixed)',
  20: 'ABS (Float)',
  21: 'Municipals Taxable (Float)',
  22: 'Municipals (Float)',
  26: "CD's (Float)",
  30: 'Other (Fixed)',
  31: 'Other (Float)',
  40: 'Other Amortizing (Fixed)',
  41: 'Other Amortizing (Float)',
  2000: 'Commercial Paper (Fixed)',
  2001: 'Commercial Paper (Float)',
  2002: 'Money Market (Fixed)',
  2003: 'Money Market (Float)'
};

export const ampReportSecClassMap: { [key: number]: string } = {
  1: 'Treasuries',
  2: 'Agencies (Fixed)',
  3: 'Corporates (Fixed)',
  4: 'Municipals Taxable (Fixed)',
  5: 'Municipals (Fixed)',
  6: "CD's (Fixed)",
  7: 'MBS (Fixed)',
  8: 'CMO (Fixed)',
  9: 'Corporates (Float)',
  10: 'MBS (Float)',
  11: 'CMO (Float)',
  12: 'Agencies (Float)',
  13: 'SBA Pools (Fixed)',
  14: 'SBA Pools (Float)',
  15: 'Stock/Preferred (Fixed)',
  16: 'Stock/Preferred (Float)',
  17: 'CMBS Pools (Fixed)',
  18: 'CMBS Pools (Float)',
  19: 'ABS (Fixed)',
  20: 'ABS (Float)',
  21: 'Municipals Taxable (Float)',
  22: 'Municipals (Float)',
  26: "CD's (Float)",
  30: 'Other (Fixed)',
  31: 'Other (Float)',
  40: 'Other Amortizing (Fixed)',
  41: 'Other Amortizing (Float)',
  1001: 'Agency Discount Notes',
  1002: 'SBA Structured (Fixed)',
  1003: 'SBA Structured (Float)',
  1004: 'Muni Leases (Fixed)',
  1005: 'Muni Leases (Float)',
  1006: 'Muni Leases Taxable (Fixed)',
  1007: 'Muni Leases Taxable (Float)',
  1008: 'MBS Private (Fixed)',
  1009: 'MBS Private (Float)',
  1010: 'CMO Private (Fixed)',
  1011: 'CMO Private (Float)',
  1012: 'CMBS Structured (Fixed)',
  1013: 'CMBS Structured (Float)',
  1014: 'Foreign Debt (Fixed)',
  1015: 'Foreign Debt (Float)',
  1016: 'NGN (Fixed)',
  1017: 'NGN (Float)',
  2000: 'Commercial Paper (Fixed)',
  2001: 'Commercial Paper (Float)',
  2002: 'Money Market (Fixed)',
  2003: 'Money Market (Float)'
};
